import {
  fetchLab,
  postLabSession,
  postLabPing,
  fetchLabSession,
  patchLabSession,
  fetchLabSessionVPNFile,
} from '@/models/labs'
import { ActionTree, ActionContext } from 'vuex'
import { LabsState } from './state'

const actions: ActionTree<LabsState, {}> = {
  getLabById: async (context: ActionContext<LabsState, {}>, labId: string) => {
    try {
      const response = await fetchLab(labId)
      context.commit('CURRENT_LAB_UPDATED', response)
      context.commit('CURRENT_LAB_SESSION_UPDATED', response.session)
    } catch (error) {
      const { message } = error
      context.dispatch('app/setError', message, { root: true })
    }
  },

  createLabSession: async (
    context: ActionContext<LabsState, {}>,
    labId: string
  ) => {
    try {
      const response = await postLabSession(labId)
      if (!response.errorCode)
        context.commit('CURRENT_LAB_SESSION_UPDATED', response)
      return response
    } catch (error) {
      const { message } = error
      context.dispatch('app/setError', message, { root: true })
    }
  },

  createLabPing: async (
    context: ActionContext<LabsState, {}>,
    labId: string
  ) => {
    try {
      await postLabPing(labId)
    } catch (error) {
      const { message } = error
      context.dispatch('app/setError', message, { root: true })
      return error
    }
  },

  getLabSession: async (
    context: ActionContext<LabsState, {}>,
    data: { labId: string; sessionId: string }
  ) => {
    try {
      const response = await fetchLabSession(data)
      context.commit('CURRENT_LAB_SESSION_UPDATED', response)
    } catch (error) {
      const { message } = error
      context.dispatch('app/setError', message, {
        root: true,
      })
    }
  },

  partialUpdateLabSession: async (
    context: ActionContext<LabsState, {}>,
    {
      labId,
      sessionId,
      status,
      cleanGlobalSession,
    }: {
      labId: string
      sessionId: string
      status: string
      cleanGlobalSession: boolean
    }
  ) => {
    try {
      const response = await patchLabSession({
        labId,
        sessionId,
        status,
      })
      if (cleanGlobalSession) {
        context.commit('CURRENT_LAB_GLOBAL_SESSION_UPDATED', null)
      } else {
        if (!response.errorCode)
          context.commit('CURRENT_LAB_SESSION_UPDATED', response)
      }

      if (status === 'terminated') {
        context.commit('CURRENT_LAB_GLOBAL_SESSION_UPDATED', null)
        context.commit('DECREMENT_CURRENT_LAB_AVAILABLE_RESETS')
      }
    } catch (error) {
      const { message } = error
      context.dispatch('app/setError', message, {
        root: true,
      })
    }
  },

  getLabSessionVPNFile: async (
    context: ActionContext<LabsState, {}>,
    data: { labId: string; sessionId: string }
  ) => {
    try {
      const response = await fetchLabSessionVPNFile(data)
      return response
    } catch (error) {
      const { message } = error
      context.dispatch('app/setError', message, { root: true })
    }
  },

  setFocusLabId: (context: ActionContext<LabsState, {}>, labId: string) => {
    context.commit('FOCUSED_LAB_ID_UPDATED', labId)
  },
}

export default actions
